import {
  ApiRequest,
  CreateParams,
  GetBaseServiceFunctions,
  queryClient,
} from '../baseService'

const BaseRoute = 'app/pics'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function GetAssignedUsersCount(params) {
  return ApiRequest.get(`${BaseRoute}/assignedUsersCount`, { params })
}

function GetDefaultPIC(params) {
  let qs = CreateParams(params)

  return ApiRequest.get(`${BaseRoute}/defaultPICs?${qs.join('&')}`)
}

const AddOrUpdateDefaultPIC = params => {
  queryClient.invalidateQueries([BaseRoute])
  return ApiRequest.post(`/app/pics/defaultPICs`, params)
}

const RemoveDefaultPIC = id => {
  return ApiRequest.delete(`/app/pics/defaultPICs?id=${id}`)
}

const API = {
  ...baseFunctions,
  GetAssignedUsersCount: GetAssignedUsersCount,
  AddOrUpdateDefaultPIC,
  GetDefaultPIC,
  RemoveDefaultPIC,
}

export default API
